import { accountId, suppressProductAnalytics, suppressProductAnalyticsEnabled } from '@gonfalon/constants/constants';

const SUPPRESS_ANALYTICS_COOKIE = 'ldsa';

// The pre-auth signup flow has no authenticated config, so email verification hands
// the verdict over as a cookie instead, honored only while the anonymous config says
// suppression is still enabled.
function suppressedByCookie(): boolean {
  try {
    if (suppressProductAnalyticsEnabled() !== true) {
      return false;
    }
    return document.cookie.split('; ').some((cookie) => cookie === `${SUPPRESS_ANALYTICS_COOKIE}=true`);
  } catch {
    return false;
  }
}

function isAuthenticated(): boolean {
  try {
    return accountId() !== undefined;
  } catch {
    return false;
  }
}

export function shouldSuppressProductAnalytics(): boolean {
  try {
    if (suppressProductAnalytics() === true) {
      return true;
    }
  } catch {
    return false;
  }

  return !isAuthenticated() && suppressedByCookie();
}
